import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Snowflake, Sun, ArrowsClockwise, Play, Crown } from "@phosphor-icons/react";
import { Heading, Stat, Btn } from "./NKDaily";

export default function SeasonsAdmin() {
  const [season, setSeason] = useState(null);

  const load = async () => {
    try { const { data } = await api.get("/season/current"); setSeason(data); }
    catch { /* */ }
  };
  useEffect(() => { load(); const id = setInterval(load, 30000); return () => clearInterval(id); }, []);

  const freeze = async () => {
    if (!confirm("Freeze the current season? This locks Country War + leaderboards. Use before the Day-30 champion ceremony.")) return;
    try { await api.post("/admin/seasons/freeze"); toast.success("Season frozen"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const unfreeze = async () => {
    try { await api.post("/admin/seasons/unfreeze"); toast.success("Season unfrozen"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const startNew = async () => {
    if (!confirm("Start a NEW season? This closes the current one (snapshots champions) and zeroes everyone's Season Score. Knowledge Rating is untouched.")) return;
    try { await api.post("/admin/seasons/start-new"); toast.success("New season started"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  const fastForward = async () => {
    const hours = Number(prompt("Advance the season clock by how many hours?", "24"));
    if (!hours) return;
    try { await api.post(`/season/admin/fast-forward?hours=${hours}`); toast.success(`Advanced ${hours}h`); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  const awardLeaders = async () => {
    if (!confirm("Crown the #1 player in EVERY country for this season? Run this after Day-30 freeze. Idempotent — safe to re-run.")) return;
    try {
      const { data } = await api.post("/season/admin/country-leaders/award");
      toast.success(`Crowned ${data.count} country leaders`);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-6">
      <Heading title="Seasons" subtitle="Every 30 days: Country War, leaderboard, championship, hall of fame." />

      {season && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <Stat label="Season" value={season.season_number} />
          <Stat label="Day" value={`${season.day} / ${season.total_days || 30}`} />
          <Stat label="State" value={(season.state || "").replace("_", " ").toLowerCase()} />
          <Stat label="Ends in" value={season.days_remaining != null ? `${season.days_remaining}d` : "—"} />
        </div>
      )}

      <section>
        <p className="eyebrow mb-3">Admin actions</p>
        <div className="flex flex-wrap gap-2">
          {season?.state !== "NATIONAL_FREEZE" ? (
            <Btn onClick={freeze} Icon={Snowflake} label="Freeze (Day 30)" tone="line" />
          ) : (
            <Btn onClick={unfreeze} Icon={Sun} label="Unfreeze" tone="accent" />
          )}
          <Btn onClick={startNew} Icon={Play} label="Start new season" tone="gold" />
          <Btn onClick={awardLeaders} Icon={Crown} label="Crown country leaders" tone="gold" />
          <Btn onClick={fastForward} Icon={ArrowsClockwise} label="Fast-forward (demo)" tone="line" />
        </div>
      </section>

      <div className="nk-card p-4 border-nk-warn/30">
        <p className="eyebrow text-nk-warn mb-2">Never touch Knowledge Rating</p>
        <p className="text-sm text-nk-mute">
          When a season ends or stats are reset, only <span className="text-nk-text font-medium">Season Score</span> is wiped.
          Knowledge Rating is permanent — that's the long-term ELO that survives across all seasons.
        </p>
      </div>
    </div>
  );
}
